import { createRouter, createWebHistory } from '@ionic/vue-router'
import { RouteRecordRaw, RouteLocationNormalized } from 'vue-router'
import { trackPageview } from '@/utils/bdash'
import { trackPageView as trackGAPageView } from '@/utils/ga'
import request from '../utils/Request'
import WithdrawalPage from '@/views/Other/Withdrawl/WithdrawalPage.vue'
import MailChangePage from '@/views/Other/MyPage/MailChangePage.vue'
import CodeVerifyPageOfMailChange from '@/views/Other/MyPage/CodeVerifyPage.vue'
import RegistrationMailPage from '../views/Registration/MailPage.vue'
import CodeVerifylPageOfRegistrationPage from '../views/Registration/CodeVerifyPage.vue'
import ForgotPassword from '../views/Login/ForgotPassword.vue'
import CompletedSendMail from '../views/Login/CompletedSendMail.vue'
import CodeVerifyOfForgotPassword from '../views/Login/CodeVerifyOfForgotPassword.vue'
import UpdateForgotPassword from '../views/Login/UpdateForgotPassword.vue'
import CompletedUpdateForgotPassword from '../views/Login/CompletedUpdateForgotPassword.vue'
import UserInfoOfRegistrationPage from '../views/Registration/UserInfoPage.vue'
import PurchaseHistoryPage from '../views/PurchaseHistoryPage.vue'
import StorageService from '../utils/StorageService'
import {checkLogin} from "@/actions/check-login";
import WebWithdrawalLogin from "@/views/WebWithdrawal/Login.vue";
import WebWithdrawalCodeVerify from "@/views/WebWithdrawal/CodeVerify.vue";
import WebWithdrawalWithdraw from "@/views/WebWithdrawal/Withdrawal.vue";
import WebWithdrawalForgotPassword from "@/views/WebWithdrawal/ForgotPassword.vue";
import WebWithdrawalNewPassword from "@/views/WebWithdrawal/NewPassword.vue";
import DeployTest from "@/views/DeployTest.vue";
import {datadogLogs} from "@datadog/browser-logs";
import ECLogin from "@/views/EC/Login.vue"
import ECUnite from "@/views/EC/Unite.vue"
import ECRegister from "@/views/EC/Register.vue"

declare module 'vue-router' {
  interface RouteMeta {
    requireAuth?: boolean
    gaTitle?: string
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/home/card/point-log',
    name: 'PointLog',
    meta: {requireAuth: true},
    component: () => import('@/views/PointLogPage.vue'),
  },
  {
    path: '/home/card/purchase-history',
    name: 'PurchaseHistory',
    meta: {requireAuth: true},
    component: PurchaseHistoryPage,
  },
  {
    path: '/home/temporary-coupon',
    name: 'TemporaryCoupon',
    component: () => import('@/views/Home/TemporaryCoupon.vue'),
  },
  {
    path: '/home/coupon',
    name: 'Coupon',
    meta: { requireAuth: true },
    component: () => import('@/views/Home/CouponPage.vue'),
  },
  {
    path: '/home/coupons/:type/:id',
    name: 'CouponDetail',
    meta: { requireAuth: true },
    props: (route: RouteLocationNormalized) => ({
      id: Number(route.params.id),
      couponType: Number(route.params.type),
    }),
    component: () => import('@/views/Home/Coupon/CouponDetailPage.vue'),
  },
  {
    path: '/home/coupon-codes/:type/:id',
    name: 'CouponScan',
    meta: { requireAuth: true },
    props: (route: RouteLocationNormalized) => ({
      id: Number(route.params.id),
      couponType: Number(route.params.type),
    }),
    component: () => import('@/views/Home/Coupon/CouponScanPage.vue'),
  },
  {
    path: '/home/coupons/used-and-expired',
    name: 'UsedAndExpiredCoupon',
    meta: { requireAuth: true },
    component: () => import('@/views/Home/Coupon/UsedAndExpiredListModal.vue'),
  },
  {
    path: '/home/store-coupons',
    name: 'StoreCoupons',
    meta: { requireAuth: true },
    component: () => import('@/views/Home/StoreCouponsPage.vue'),
  },
  {
    path: '/home/ec-coupons',
    name: 'EcCoupons',
    meta: { requireAuth: true },
    component: () => import('@/views/Home/EcCouponsPage.vue'),
  },
  {
    path: '/home/preview/store-coupons',
    name: 'PreviewStoreCoupons',
    meta: { requireAuth: true },
    component: () => import('@/views/Home/StoreCouponsPage.vue'),
    props: { isPreview: true },
  },
  {
    path: '/home/preview/ec-coupons',
    name: 'PreviewEcCoupons',
    meta: { requireAuth: true },
    component: () => import('@/views/Home/EcCouponsPage.vue'),
    props: { isPreview: true },
  },
  {
    path: '/home/card/point-exchange',
    name: 'PointExchange',
    meta: { requireAuth: true },
    component: () => import('@/views/Home/Card/PointExchangePage.vue'),
  },
  {
    path: '/home/card/point-exchange/:id',
    name: 'PointExchangeDetail',
    meta: { requireAuth: true },
    props: (route: RouteLocationNormalized) => ({ id: Number(route.params.id) }),
    component: () => import('@/views/Home/Card/PointExchangeDetailPage.vue'),
  },
  {
    path: '/web-withdrawal/login',
    name: 'WebWithdrawalLogin',
    component: WebWithdrawalLogin,
  },
  {
    path: '/web-withdrawal/code-verify',
    name: 'WebWithdrawalCodeVerify',
    component: WebWithdrawalCodeVerify,
  },
  {
    path: '/web-withdrawal/withdraw',
    name: 'WebWithdrawalWithdraw',
    component: WebWithdrawalWithdraw,
  },
  {
    path: '/web-withdrawal/forgot-password',
    name: 'WebWithdrawalForgotPassword',
    component: WebWithdrawalForgotPassword,
  },
  {
    path: '/web-withdrawal/new-password',
    name: 'WebWithdrawalNewPassword',
    component: WebWithdrawalNewPassword,
  },
  {
    path: '/other/withdrawal',
    name: 'Withdrawal',
    meta: {requireAuth: true},
    component: WithdrawalPage
  },
  {
    path: '/other/update-my-page',
    name: 'UpdateMyPage',
    meta: {requireAuth: true},
    component: () => import('@/views/Other/MyPage/UpdateMyPage.vue')
  },
  {
    path: '/other/password-change',
    name: 'PasswordChange',
    meta: {requireAuth: true},
    component: () => import('@/views/Other/PasswordChange/PasswordChange.vue'),
  },
  {
    path: '/other/my-page/mail-change',
    name: 'MailChangePage',
    meta: {requireAuth: true},
    component: MailChangePage,
  },
  {
    path: '/other/my-page/code-verify',
    name: 'CodeVerifyPageOfMailChange',
    meta: {requireAuth: true},
    component: CodeVerifyPageOfMailChange,
  },
  {
    path: '/login/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/login/forgot-password/completed-send-mail',
    name: 'CompletedSendMail',
    component: CompletedSendMail,
  },
  {
    path: '/login/forgot-password/code-verify',
    name: 'CodeVerifyOfForgotPassword',
    component: CodeVerifyOfForgotPassword,
  },
  {
    path: '/login/forgot-password/update',
    name: 'UpdateForgotPassword',
    component: UpdateForgotPassword,
  },
  {
    path: '/login/forgot-password/completed',
    name: 'CompletedUpdateForgotPassword',
    component: CompletedUpdateForgotPassword,
  },
  {
    path: '/registration/mail',
    name: 'RegistrationMil',
    component: RegistrationMailPage,
    meta: {requireAuth: true, gaTitle: '会員登録_メールアドレス入力'},
  },
  {
    path: '/registration/code-verify',
    name: 'CodeVerifyOfRegistration',
    component: CodeVerifylPageOfRegistrationPage,
    meta: {requireAuth: true, gaTitle: '会員登録_メール認証'},
  },
  {
    path: '/registration/user-info',
    name: 'UserInfoOfRegistration',
    component: UserInfoOfRegistrationPage,
    meta: {requireAuth: true, gaTitle: '会員登録_ユーザー情報入力'},
  },
  {
    path: '/deploy-test',
    name: 'DeployTest',
    component: DeployTest,
  },
  // Not Found page
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
  },
  {
    path: '/ec/login',
    name: 'ECLogin',
    component: ECLogin,
    meta: {requireAuth: true},
  },
  {
    path: '/ec/unite',
    name: 'ECUnite',
    component: ECUnite,
    meta: {requireAuth: true},
  },
  {
    path: '/ec/register',
    name: 'ECRegister',
    component: ECRegister,
    meta: {requireAuth: true},
  },
]

if (import.meta.env?.VITE_ENV == 'development') {
  routes.push({
    path: '/',
    name: 'DevHome',
    component: () => import('@/views/DevHomePage.vue'),
  },)
}
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

const screensNotRequiredAuth = ['Login', 'CodeVeryfyOfLogin']

router.beforeEach(async (to, from, next) => {
  // 初回起動時は、イントロダクションページを表示
  // Todo: 初回起動フラグの判定は、どうするのが良いか？
  const didStartupEnter = await StorageService.get('didStartupEnter') ?? false
  // console.log('didStartupEnter', didStartupEnter)

  if(to.name === 'HomePage') {

    if (!didStartupEnter) {
      // await StorageService.set('didStartupEnter', true)
      return next({ name: 'IntroductionWhenStartupPage' })
    }

    const isLoggedIn = await checkLogin();
    console.log('HomePage: user loggedIn', isLoggedIn)
    // ToDo: userの存在チェックでよいのか？
    if (!isLoggedIn) {
      console.log('user not found')
      return next({ name: 'FirstOfConfirmationWhenStartup' })
    }
  }

  if (to.meta.requireAuth) {
    await request.get('/health-access-token').catch(async (err) => {
      if (!err.response) {
        datadogLogs.logger.error(err);
      }
      else if (err.response.status == 401) {
       return next({ name: 'Login' });
      }
    })
  }

  if (screensNotRequiredAuth.includes(to.name?.toString() || '')) {
    const user = await StorageService.get('user')

    if (user && user.is_updated_profile) {
      return next({name: 'Home'})
    }
  }

  // マッチするルートがない場合、NotFoundコンポーネントにリダイレクト
  // console.log('to', to.matched)
  if (to.matched.length === 0) {
    console.log('not found')
    return next({ name: 'NotFound' });
  } else {
    next();
  }

})

const BDASH_TARGET_PATHS = ['/home/store-coupons', '/home/ec-coupons']

// SPA遷移時のみpage viewを手動送信（初回ロードはbdashが自動送信）
router.afterEach((to, from) => {
  if (to.meta.gaTitle) {
    trackGAPageView(to.path, to.meta.gaTitle)
  }
  if (!from.name) return
  if (to.path === from.path) return
  if (BDASH_TARGET_PATHS.some(path => to.path.startsWith(path))) {
    trackPageview()
  }
})

export default router
